import { render, staticRenderFns } from "./PopupIssueTypeCriteria.vue?vue&type=template&id=477cb375&scoped=true"
import script from "./PopupIssueTypeCriteria.vue?vue&type=script&lang=js"
export * from "./PopupIssueTypeCriteria.vue?vue&type=script&lang=js"
import style0 from "./PopupIssueTypeCriteria.vue?vue&type=style&index=0&id=477cb375&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477cb375",
  null
  
)

export default component.exports